// Module
var code = "<div> <div ng-if=\"user && selector.profiles && selector.profiles.length > 1\" class=\"field\"> <label style=\"margin-bottom:10px\">Profile</label> <su-select options=\"selector.profiles\" selected=\"user.access_profile\" drop-name=\"{{'profiles.chooseAProfile'|translate}}\" class=\"dropdown--unset\"></su-select> </div> </div>";
// Exports
module.exports = code;